export default __webpack_public_path__ + "locales/ja-JP/DeleteThirdPartyDialog.json?hash=b2b2134a4937df0629fe864b711fb751";